<script setup>
import { computed } from 'vue'
import { t, message } from '../lib/i18n.mjs'
const props = defineProps({
  focusId: String,
  retrieval: Object,
  threshold: Number,
  busy: Boolean,
  loading: Boolean,
  error: String,
  task: Object,
})
defineEmits(['threshold', 'analyze', 'close', 'refresh'])
const candidates = computed(() => props.retrieval?.candidates.filter((c) => c.score >= props.threshold) || [])
const taskIsFocus = computed(
  () => (props.task?.operation || props.task?.request?.operation) === 'focus_links',
)
</script>
<template>
  <section v-if="focusId" class="focus-panel" :aria-label="t('焦点相关性')">
    <div class="focus-panel-heading">
      <strong>{{ t('焦点') }} · {{ focusId }}</strong>
      <button class="subtle-button" :disabled="busy" @click="$emit('close')">{{ t('取消焦点') }}</button>
    </div>
    <p v-if="loading" role="status">{{ t('正在计算相关性…') }}</p>
    <p v-else-if="error" role="alert">
      {{ message(error) }} <button class="subtle-button" @click="$emit('refresh')">{{ t('重试') }}</button>
    </p>
    <template v-else-if="retrieval">
      <label class="focus-threshold"
        >{{ t('相关性阈值') }} {{ threshold.toFixed(2) }}
        <input
          type="range"
          min="0"
          max="1"
          step="0.01"
          :value="threshold"
          :disabled="busy"
          :aria-label="t('相关性阈值')"
          @input="$emit('threshold', Number($event.target.value))"
        />
      </label>
      <div class="focus-panel-actions">
        <span aria-live="polite"
          >{{ t('已选 {count} 个候选单元', { count: candidates.length }) }} /
          {{ retrieval.candidates.length }}</span
        >
        <button class="primary-button" :disabled="busy || !candidates.length" @click="$emit('analyze')">
          {{ t('分析焦点关系') }}
        </button>
      </div>
      <details v-if="candidates.length">
        <summary>{{ t('查看候选及分数') }}</summary>
        <ul class="focus-candidates">
          <li
            v-for="candidate in candidates"
            :key="candidate.id"
            :title="`${t('语义')} ${candidate.semantic.toFixed(2)} · ${t('实体')} ${candidate.entity.toFixed(2)} · ${t('时间')} ${candidate.time.toFixed(2)}`"
          >
            <span>{{ candidate.id }} · {{ candidate.label }}</span
            ><span>{{ candidate.score.toFixed(2) }}</span>
          </li>
        </ul>
      </details>
    </template>
    <p v-if="taskIsFocus" class="focus-task-status" role="status">
      {{ message(task.error || task.progress?.stage || t('正在分析…')) }}
    </p>
  </section>
</template>
